import React from 'react';
import CommonFileBody from '@rd-web-markets/shared/dist/folders_and_files/modal/CommonFileBody';
export default props => /*#__PURE__*/React.createElement(CommonFileBody, props);